export default __webpack_public_path__ + "static/media/vivabonito3.1b58e3cf.jpg";